const zeroDecimalCurrencies = new Set([
  'BIF',
  'CLP',
  'DJF',
  'GNF',
  'JPY',
  'KMF',
  'KRW',
  'MGA',
  'PYG',
  'RWF',
  'VND',
  'VUV',
  'XAF',
  'XOF',
  'XPF',
]);
const twoDecimalWholeAmountCurrencies = new Set(['ISK', 'UGX']);

export function majorFromMinor(amountMinor: number, currency: string): number {
  return amountMinor / factor(currency);
}

export function minorFromMajor(value: string, currency: string): number | null {
  const match = value.trim().match(/^(-?)(\d+)(?:[.,](\d+))?$/);
  if (!match) return null;

  const [, sign, whole, fractional = ''] = match;
  const scale = factor(currency);
  const allowedFractionDigits = scale === 1 ? 0 : 2;
  if (
    fractional.length > allowedFractionDigits ||
    (twoDecimalWholeAmountCurrencies.has(normalize(currency)) && fractional.length > 0)
  ) {
    return null;
  }

  const wholeAmount = Number(whole);
  const fraction = fractional.length === 0 ? 0 : Number(fractional.padEnd(2, '0'));
  const result = wholeAmount * scale + fraction;
  return Number.isSafeInteger(result) ? (sign === '-' ? -result : result) : null;
}

function factor(currency: string): number {
  return zeroDecimalCurrencies.has(normalize(currency)) ? 1 : 100;
}

function normalize(currency: string): string {
  return currency.trim().toUpperCase();
}
